import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const InvestmentsDashboard = () => {
  const [investments, setInvestments] = useState([]);
  const [filter, setFilter] = useState("All");
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const fetchInvestments = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "investments"));
        const investmentsData = [];
        let total = 0;

        querySnapshot.forEach((doc) => {
          const investment = { id: doc.id, ...doc.data() };
          investmentsData.push(investment);

          if (investment.amount && !isNaN(investment.amount)) {
            total += Number(investment.amount);
          }
        });

        setInvestments(investmentsData);
        setTotalAmount(total);
      } catch (e) {
        console.error("Error fetching investments: ", e);
      }
    };

    fetchInvestments();
  }, []);

  const filteredInvestments =
    filter === "All"
      ? investments
      : investments.filter((inv) => inv.status === filter);

  const containerStyle = {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    background: "#09141b", // Dark background
    color: "#ffffff", // White text
    minHeight: "100vh",
  };

  const headerStyle = {
    textAlign: "center",
    marginBottom: "20px",
    color: "#4caf50", // Green header
  };

  const filterStyle = {
    marginBottom: "20px",
    textAlign: "center",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    background: "#1c252b", // Slightly lighter dark background
    borderRadius: "8px",
    overflow: "hidden",
  };

  const thTdStyle = {
    border: "1px solid #444", // Darker border
    padding: "8px",
    textAlign: "center",
    color: "#ffffff", // White text
  };

  const thStyle = {
    ...thTdStyle,
    backgroundColor: "#4CAF50", // Green header background
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Investments Dashboard</h1>

      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2>
          Total Investment Amount:{" "}
          <span style={{ color: "#4caf50" }}>
            ${totalAmount.toLocaleString("en-US", { minimumFractionDigits: 2 })}
          </span>
        </h2>
      </div>

      <div style={filterStyle}>
        <label htmlFor="statusFilter" style={{ marginRight: "10px" }}>
          Filter by Status:
        </label>
        <select
          id="statusFilter"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #444",
            background: "#1c252b", // Dropdown background
            color: "#ffffff", // Dropdown text color
          }}
        >
          <option value="All">All</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
          <option value="Pending">Pending</option>
        </select>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Investment ID</th>
            <th style={thStyle}>User ID</th>
            <th style={thStyle}>Car ID</th>
            <th style={thStyle}>Amount</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvestments.map((inv) => (
            <tr key={inv.id}>
              <td style={thTdStyle}>{inv.investmentID}</td>
              <td style={thTdStyle}>{inv.userID}</td>
              <td style={thTdStyle}>{inv.carID}</td>
              <td style={thTdStyle}>
                ${Number(inv.amount)?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                }) || "N/A"}
              </td>
              <td style={thTdStyle}>{inv.status || "N/A"}</td>
              <td style={thTdStyle}>
                {inv.date
                  ? new Date(inv.date.seconds * 1000).toLocaleString()
                  : "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvestmentsDashboard;
